import { createApp, defineAsyncComponent } from "vue";
import { clickOutside } from "../directives/click-outside";
import { confirm } from "../directives/confirm";
import { canPermission } from "../directives/can-permission";
import { CssVariables } from "../directives/css-variables";
import "../common";
import { info } from "./init";
import { translate } from "./translation";
// import { setting } from './Setting';

declare var window;

window.vueInstances = window.vueInstances ?? {};

export function createVueApp(
  name: string,
  tier: string = "apps",
  callback = null
) {
  const component = defineAsyncComponent(
    () => import(`@/${tier}/${name}/${name}.vue`)
  );
  window.vueInstances[name] = (id, params: any = {}) => {
    return new Promise((resolve) => {
      const app = createApp(component, params);
      app.provide("app", app);
      app.config.globalProperties.$params = params;
      properties(app);
      directives(app);
      mixins(app);
      components(app);
      if (callback) {
        callback(app);
      }
      app.mount(`#${id}`);
      resolve(app);
    });
  };
  document.addEventListener("readystatechange", async (event: any) => {
    if (event.target.readyState === "complete") {
      if (
        window.hasOwnProperty("vueApps") &&
        window.vueApps.hasOwnProperty(name)
      ) {
        window.vueApps[name]?.dispatch?.();
      }
    }
  });
}

function properties(app) {
  app.config.globalProperties.$info = info();
  // app.config.globalProperties.$setting = setting;
  app.config.globalProperties.translate = translate;
  app.config.globalProperties.can = (permission) => true;
  app.config.globalProperties.isSecureContext = window.isSecureContext;
}

function directives(app) {
  app.directive("click-outside", clickOutside);
  app.directive("confirm", confirm);
  app.directive("can", canPermission);
  app.directive("css-vars", CssVariables);
}

function components(app) {}

function mixins(app) {}
